// 2026-10-02 (Bez): the CADINU V1 -> V2 token migration is archived with the other old products (see lottery.ts).
// MIGRATION_ARCHIVED=1 (build-time env, passed through next.config.mjs `env`) hides it from the menu and the home rows;
// /migration keeps working (note on top, approve + migrate unchanged) and is listed on /legacy. docs/PARKED-PRODUCTS-20261001.md.
export const MIGRATION_ARCHIVED = process.env.MIGRATION_ARCHIVED === '1'
